import urls from "global/constants/UrlConstants";
import { getNoAuthCallParams, makeCall } from "utils/service";

export interface ContactFormPayload {
  first_name: string;
  last_name: string;
  email: string;
  subject: string;
  message: string;
}

export const submitContactForm = async (
  contactForm: ContactFormPayload
): Promise<any> => {
  try {
    const callParams = await getNoAuthCallParams("POST", contactForm);
    const response: any = await makeCall(urls.CONTACT_US, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
